import React from 'react'
import Graph from './graph'
import { TidewaysContext } from '../app/context'
import TidewaysNavigator from '../app/navigator'
import { WithEnvironmentAndService } from '../helper/WithEnvironmentAndService'
import ExternalCallsGraph from './external-calls-graph'

interface Props {
    tidewaysContext: TidewaysContext
    external: boolean
    navigator: TidewaysNavigator
    singleCol: boolean
}

interface State {
    sharedTimeslot: string | null
}

export class AllServicesGraphs extends React.PureComponent<Props, State> {
    public state: State = {
        sharedTimeslot: null,
    }

    public static defaultProps = {
        external: false,
    }

    render = () => {
        const { external, tidewaysContext, singleCol } = this.props
        const services = tidewaysContext.getServicenames(external)

        return (
            <WithEnvironmentAndService
                render={({ setService }) => (
                    <div className={singleCol ? 'service-overview single' : 'service-overview'}>
                        {services.map(service => (
                            <div
                                onClick={() => setService(service)}
                                key={service}
                                className="monitor application-graph jquery-tooltip-reference"
                                style={{ cursor: 'pointer' }}
                            >
                                {this.props.external ? (
                                    <ExternalCallsGraph
                                        responseType="95p"
                                        service={service}
                                        shareTimeslot={(timeslot: string | null) => this.setState({ sharedTimeslot: timeslot })}
                                        sharedTimeslot={this.state.sharedTimeslot}
                                    />
                                ) : (
                                    <Graph
                                        responseType="95p"
                                        service={service}
                                        shareTimeslot={(timeslot: string | null) => this.setState({ sharedTimeslot: timeslot })}
                                        sharedTimeslot={this.state.sharedTimeslot}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                )}
            />
        )
    }
}
